import type { BrandKitFont } from "../shared/types";

export const BRAND_KIT_FONT_FALLBACK = "Helvetica" as const;

export function brandKitFontPreviewFamily(font: BrandKitFont): string {
  return font.captureStatus === "ready" && font.mediaUrl
    ? `brand-kit-${font.id}`
    : BRAND_KIT_FONT_FALLBACK;
}

export function brandKitFontStatusLabel(font: BrandKitFont): string {
  return font.captureStatus === "ready"
    ? "Exact file"
    : `${BRAND_KIT_FONT_FALLBACK} fallback · exact file required`;
}
